// i18n area 'cluster' — locale nl-NL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.nl-NL.meta.json.
import type { enUS } from './cluster'

export const nlNL: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantietoegangen',
      subtitle: 'De servicedeur van de node: de alleen-lezen-toegang met tijdelijk wachtwoord en het noodaccount met het wachtwoord uit de kluis',
      readOnlyTitle: 'Alleen-lezen-toegang (trantor)',
      stateNone: 'gesloten',
      stateGranted: 'open',
      stateGrantedPending: 'verleend — wordt toegepast op de node',
      grantedBy: 'Verleend door',
      grantedAt: 'Verleend op',
      expiresAt: 'Verloopt op',
      reason: 'Reden',
      endedAt: 'Gesloten',
      endedReason: {
        revoked: 'ingetrokken',
        expired: 'verlopen (TTL)',
        reboot: 'herstart van de node',
        failed: 'niet toegepast (taak mislukt)'
      },
      grant: 'Alleen-lezen-toegang verlenen…',
      grantTitle: 'Alleen-lezen-toegang verlenen',
      grantSubmit: 'Verlenen',
      grantError: 'De verlening is geweigerd',
      grantConfirm: 'TVirt genereert een tijdelijk wachtwoord voor de systeemgebruiker «trantor» (alleen lezen: journal en diagnostiek, geen sudo) en stelt het met een taak in op de node. Het wachtwoord wordt ÉÉN keer getoond, bij de bevestiging; het vervalt bij het verlopen, bij intrekking of bij de volgende herstart van de node.',
      reasonLabel: 'Reden',
      reasonHint: 'Waarom je de deur opent: het komt in de verlening, in de audit en in het journaal',
      ttlLabel: 'Duur',
      ttlHours: '{n} u',
      revoke: 'Alleen-lezen-toegang intrekken…',
      revokeTitle: 'Alleen-lezen-toegang intrekken',
      revokeSubmit: 'Intrekken',
      revokeError: 'De intrekking is geweigerd',
      revokeConfirm: 'De verlening eindigt nu en een taak vergrendelt de gebruiker «trantor» op de node opnieuw: het tijdelijke wachtwoord werkt niet meer.',
      passwordTitle: 'Alleen-lezen-wachtwoord',
      passwordOnce: 'Dit wachtwoord wordt ÉÉN keer getoond: kopieer het nu. Het wordt nergens opgeslagen en kan niet opnieuw worden gelezen — raak je het kwijt, verleen dan opnieuw.',
      passwordUser: 'Gebruiker',
      passwordLabel: 'Wachtwoord',
      passwordHint: 'Geldig tot {until}, of tot de volgende herstart van de node; bruikbaar zodra de verleningstaak is voltooid. Toegang: ssh trantor@<adres van de node>.',
      emergencyTitle: 'Laatste noodtoegang (trantor-emergency)',
      lastLogin: '{time} via {via} vanaf {from}',
      lastLoginNone: 'geen waargenomen',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'console',
        sudo: 'sudo',
        unknown: 'onbekend'
      },
      emergencyHint: 'Het noodaccount «trantor-emergency» (volledige sudo) is altijd ingeschakeld met het wachtwoord dat bij de installatie van de node is gegenereerd en in de kluis wordt bewaard: TVirt kent het niet, roteert het niet en herstelt het niet. Elke aanmelding wordt hier en in het gebeurtenissenjournaal gemeld.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall van de nodes',
      subtitle: 'De houding van de nftables-ruleset die elke node op zichzelf toepast — de enige firewall van een node (firewalld is uitgeschakeld)',
      modeLabel: 'Houding',
      mode: {
        disabled: 'Uitgeschakeld — geen ruleset op de nodes',
        permissive: 'Permissief — telt en logt, verwerpt niets',
        enforced: 'Afgedwongen — alleen het afgeleide register komt binnen'
      },
      hint: {
        disabled: 'Zoals vandaag: de nodes dragen geen ruleset. Schakel over naar permissief om te LEZEN wat verworpen zou worden voordat het verworpen wordt.',
        permissive: 'Elke node past zijn eigen afgeleide ruleset toe met policy accept: wat de afgedwongen houding zou verwerpen, wordt geteld en gelogd (journal-prefix „tvirt-node would-drop:”). Niets wordt geblokkeerd.',
        enforced: 'Elke node past zijn eigen afgeleide ruleset toe met policy drop: ssh en API van overal, store / live migration / overlay / Ceph alleen van de leden, de listeners van de netwerkdiensten vanuit het bediende netwerk. Elke omschakeling is een apply met bevestiging — een node die niet kan bevestigen, draait zichzelf terug.'
      },
      confirmTitle: 'De firewall van de nodes afdwingen?',
      confirmBody: 'Elke node past de ruleset toe met bevestiging: hij sondeert backend, store en ssh door de nieuwe regels heen binnen de deadline en bevestigt — anders keert hij zelf terug naar de vorige ruleset. Lees eerst de tellers van de permissieve houding op de nodes.',
      confirmSubmit: 'Afdwingen',
      confirmCancel: 'Annuleren',
      lensTitle: 'Firewall van de node',
      loadError: 'Kon de firewall-lens van de node niet laden',
      noReport: 'Nog geen firewallrapport van deze node — de worker rapporteert bij de volgende pass',
      firewalldActive: 'Op deze node draait firewalld: de node-firewall weigert zich ernaast toe te passen (firewalld maskeren)',
      conditionUnconfirmed: 'Nog geen bevestigde ruleset — de node staat open',
      conditionRolledBack: 'De laatste apply is teruggedraaid — dezelfde generatie wordt niet opnieuw geprobeerd totdat het register verandert of de houding opnieuw wordt omgeschakeld',
      lastError: 'Laatste fout',
      posture: 'Houding',
      observedAt: 'Waargenomen',
      desiredGeneration: 'Gewenste generatie',
      componentTitle: 'Node-component',
      componentSubtitle: 'tvirt-node-firewall — past bij het opstarten de bevestigde ruleset toe, draait een onbevestigde zelf terug',
      componentAbsent: 'Het component heeft nog niet gerapporteerd',
      phase: 'Fase',
      phases: {
        none: 'Nooit toegepast',
        applied: 'Toegepast — wacht op bevestiging',
        confirmed: 'Bevestigd',
        rolledBack: 'Teruggedraaid'
      },
      generation: 'Generatie',
      appliedAt: 'Toegepast op',
      confirmedAt: 'Bevestigd op',
      deadline: 'Rollback-deadline',
      lastRollback: 'Laatste rollback',
      registryTitle: 'Afgeleid register',
      registrySubtitle: 'De poorten die deze node opent, per klasse en oorsprong — afgeleid van het cluster, nooit met de hand bewerkt',
      registryEmpty: 'Niets afgeleid — houding uitgeschakeld zonder bevestigde ruleset, of nog geen rapport',
      colClass: 'Klasse',
      colPort: 'Poort',
      colSource: 'Bron',
      colOrigin: 'Oorsprong',
      classes: {
        public: 'Publiek',
        internode: 'Inter-node',
        tenant: 'Tenant'
      },
      sourceMembers: 'alleen de leden',
      sourceAnywhere: 'overal',
      sourceBridge: 'op {iface}'
    },
    derivationDerived: 'afgeleid',
    derivationDiverged: 'afgeweken',
    derivationDerivedTip: 'Het netwerkdocument is AFGELEID van fabric {fabric} en komt nog overeen met de render op de huidige invoer — klik voor het derivatieplan.',
    derivationDivergedTip: 'De derivatie van fabric {fabric} is veranderd na de laatste apply (fabric, bekabeling, rollen of referenties) — klik voor de openstaande diff.',
    derivationRetiring: {
      one: '{n} adres loopt leeg',
      other: '{n} adressen lopen leeg'
    },
    standaloneHint: 'Deze node heeft geen cluster: het is nog niet geïnstalleerd. Clusters worden bij de installatie aangemaakt OF gejoind — de token die de Server-tabel van een lid genereert, geef je aan de installer mee (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Je rechten dekken een scope, niet het hele cluster: de vlootinventaris — nodes, instellingen en apparaten — is alleen zichtbaar voor clusterbeheerders.',
    phaseReady: 'Gereed',
    phaseForming: 'In vorming',
    storeMembers: 'Leden van de store',
    watermark: 'Convergentiedrempel',
    configGeneration: 'Configuratiegeneratie',
    converged: 'synchroon',
    behind: 'achter — {m} / {n}',
    revision: 'Revisie',
    rolesTitle: 'Netwerkrollen',
    rolesSubtitle: 'Adressen per lid voor elke verkeersklasse — de connectiviteit leeft in het hostnetwerk',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'erft management',
    settingsTitle: 'Instellingen',
    settingsSubtitle: 'Beveiligingsbeleid op clusterniveau — door elke node beoordeeld vanuit zijn eigen lokale replica',
    taskRetentionTitle: 'Retentie van tasks',
    taskRetentionSubtitle: 'Uniforme GC voor alle tasks — afgeronde tasks voorbij de leeftijd of het plafond worden opgeruimd, lopende tasks nooit',
    taskRetentionMaxAge: 'Maximale leeftijd (dagen)',
    taskRetentionMaxCount: 'Maximaal aantal tasks',
    eventRetentionTitle: 'Gebeurtenisretentie',
    eventRetentionSubtitle: 'De GC van het journaal — een beleid onafhankelijk van dat van de taken: de taak is een wachtrij, de gebeurtenis is geheugen',
    eventRetentionMaxAge: 'Maximale leeftijd (dagen)',
    eventRetentionMaxCount: 'Maximaal opgeslagen gebeurtenissen',
    spaceThresholdsTitle: 'Ruimtedrempels',
    spaceThresholdsSubtitle: 'Wanneer een vollopende storage het journaal (en de meldingen) bereikt',
    spaceLowPct: 'Waarschuwing vanaf (% gebruikt)',
    spaceCriticalPct: 'Kritiek vanaf (% gebruikt)',
    spaceOrderError: 'Kritiek kan niet onder de waarschuwing liggen',
    spaceThresholdsHint: 'Alleen de ingangen worden geconfigureerd: de uitgang leidt de engine af, 5 punten onder elke drempel, zodat een storage op de lijn nooit een metronoom wordt',
    failoverReserveTitle: 'Failover-reserve',
    failoverReserveSubtitle: 'N+1 admission control — RAM die vrij wordt gehouden zodat het cluster zijn werklast opnieuw kan starten na het verlies van nodes',
    failoverReserveTolerate: 'Nodes waarvan het verlies verdragen moet worden',
    failoverReserveOff: '0 — reserve uit: geen enkele start wordt ooit geweigerd wegens failovercapaciteit',
    failoverReserveOn: 'Een start die de reserve zou aantasten wordt geweigerd met een 412 die de cijfers uitlegt',
    networkShapingTitle: 'Bandbreedte-fairness',
    networkShapingSubtitle: 'De drie typologiegewichten van de shaping-boom per uplink — ze grijpen alleen in bij concurrentie',
    networkShapingRest: 'Gewicht van de rest (control plane, storage, replica\'s)',
    networkShapingOverlay: 'Gewicht van de overlay-netwerken',
    networkShapingLiveMigration: 'Gewicht van live migration',
    networkShapingHint: 'Gegarandeerd aandeel = gewicht / som van de drie (standaard 300 / 100 / 200, elk van 1 tot 10000); op een vrije link mag elke klasse de hele bandbreedte nemen',
    debugModeTitle: 'Debugmodus',
    debugModeSubtitle:
      'Gedetailleerde foutmeldingen in de generieke GUI-meldingen — om de echte oorzaak te zien wanneer een actie die ‘mislukt’ is, in werkelijkheid is geslaagd',
    debugModeLabel: 'Debugmodus ingeschakeld',
    debugModeOn: 'Generieke foutmeldingen voegen de onderliggende oorzaak toe — interne details zichtbaar voor elke operator',
    debugModeOffHint: 'Uit — generieke foutmeldingen blijven generiek, zonder interne details',
    nodeDetailsAction: 'Nodedetails',
    node: {
      docTitle: 'Node',
      notFound: 'Node niet gevonden',
      tabOverview: 'Overzicht',
      tabStats: 'Statistieken',
      tabNetwork: 'Netwerk',
      tabSettings: 'Lokale instellingen',
      identityTitle: 'Identiteit',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-poort',
      revision: 'Configuratierevisie',
      versionsTitle: 'Waargenomen versies',
      heartbeatSubtitle: 'De laatste status die de node over zichzelf heeft gemeld',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-model',
      memoryTitle: 'Geheugen',
      hugePagesTitle: "Enorme pagina's",
      hugePagesPool: '{size}: {free} vrij van {total}',
      hugePagesNone: 'Geen pool',
      hugePagesNoneHint: "De node heeft geen enorme pagina's gereserveerd: VM's die erom vragen kunnen hier niet starten. De pool wordt op de node gedeclareerd, met de kernelparameters hugepagesz en hugepages of door nr_hugepages te schrijven.",
      usageTitle: 'Huidig gebruik',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'niet waargenomen — geen actuele meting',
      statsNoData: 'Geen gegevens in dit interval — de reeksen van de node worden door de node zelf bemonsterd en lokaal geserveerd.',
      observedTitle: 'Waargenomen status',
      observedSubtitle: 'Diensten en assets lokaal op de node, zoals de worker ze ziet'
    },
    editRolesTitle: 'Netwerkrollen bewerken',
    memberNode: 'Node',
    memberIp: 'IP-adres',
    addMember: 'Lid toevoegen',
    lmInherit: 'De management-adressen gebruiken',
    roleIpHint: 'Leden toevoegen en weghalen mag altijd; het IP van een bestaand lid ter plekke wijzigen wordt geweigerd — de flow voor IP-migratie komt in een latere ronde.',
    roleError: 'De rollen konden niet worden bijgewerkt',
    nodesTitle: 'Nodes',
    addNodeTitle: 'Node aan het cluster toevoegen',
    addNode: 'Node toevoegen',
    addNodeError: 'De node kon niet worden voorgeregistreerd',
    nodeName: 'Naam van de node',
    nodeNameHint: 'moet overeenkomen met de naam die bij de installatie is gekozen',
    nodeIp: 'Management-IP',
    colName: 'Naam',
    colPhase: 'Fase',
    colServices: 'Diensten',
    colWatermark: 'Watermark',
    colLastSeen: 'Laatste contact',
    colUps: 'UPS',
    upsCordonChip: 'UPS-cordon',
    upsCordonTip: 'De node heeft zichzelf veroordeeld op de feiten van zijn UPS ({time}): hij heft het cordon zelf op zodra het net stabiel is en de accu is opgeladen',
    upsUnreachable: 'UPS onbereikbaar',
    upsOnBattery: 'Op accu',
    upsOnLine: 'Op netstroom',
    upsLowBattery: 'accu bijna leeg',
    upsNoEstimateChip: 'resterende tijd niet geschat',
    upsNoEstimateTip: 'De UPS publiceert geen schatting van de resterende tijd: de node wordt alleen veroordeeld via de LB-vlag (accu bijna leeg) van de UPS — stel battery.runtime.low / LB in op de UPS zelf',
    upsLaneTip: 'UPS-afsluitpad sinds {since}: veroordeeld door {by}',
    upsUnit: 'eenheid',
    upsStatus: 'NUT-status',
    upsLoad: 'belasting',
    upsOnBatterySince: 'op accu sinds',
    upsOnLineSince: 'op netstroom sinds',
    upsError: 'fout',
    upsObservedAt: 'waargenomen',
    upsNone: 'geen UPS-eenheid bedient deze node',
    upsBy: {
      runtime: 'resterende tijd onder de drempel',
      lowBattery: 'LB-vlag van de UPS',
    },
    upsLane: {
      evacuate: 'evacuatie',
      local: 'afsluiten ter plaatse',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'gasten stoppen',
      stoppingServices: 'services stoppen',
      poweredOff: 'uitgeschakeld',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-eenheden en drempels: node veroordeeld bij resterende tijd ≤ drempel of LB-vlag (altijd gehonoreerd), hervatting met hysterese',
    upsRuntimeThreshold: 'Drempel resterende tijd (s)',
    upsRuntimeThresholdHint: 'Op accu, met geschatte resterende tijd ≤ drempel sluit de node ordelijk af (standaard 300)',
    upsResumeStable: 'Netstroom stabiel gedurende (s)',
    upsResumeStableHint: 'Hervatten alleen met ononderbroken netstroom sinds minstens zoveel seconden (standaard 60)',
    upsResumeCharge: 'Minimale lading bij hervatting (%)',
    upsResumeChargeHint: 'En accu minstens tot dit percentage opgeladen (standaard 25)',
    upsPolicyNote: 'De LB-vlag (accu bijna leeg) van de UPS veroordeelt altijd en kan niet worden uitgeschakeld; er is geen drempel op de tijd op accu. Elke eenheid kan de drie getallen overschrijven.',
    upsUnitNew: 'nieuwe eenheid',
    upsUnitSelectors: '{n} tag-selector(s) (alleen CLI)',
    upsUnitName: 'Naam van de eenheid',
    upsUnitMode: 'Modus',
    upsModeExternal: 'extern (upsd van een ander)',
    upsModeManaged: 'beheerd (UPS aangesloten op een node)',
    upsUnitUpsname: 'NUT-naam (upsname)',
    upsUnitHost: 'upsd-host',
    upsUnitAttachedNode: 'Aangesloten node',
    upsUnitDriver: 'NUT-driver',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Apparaat van de driver',
    upsUnitDeviceHint: 'de regel port= van ups.conf: leeg = auto',
    upsUnitPort: 'upsd-poort',
    upsUnitServedNodes: 'Bediende nodes',
    upsUnitServedNodesHint: 'nodenamen gescheiden door komma’s (tag-selectors gaan via de CLI)',
    upsUnitOverrideHint: 'leeg = clusterstandaard',
    upsUnitAdd: 'Eenheid toevoegen',
    unreachableSince: 'Onbereikbaar — laatste heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Het overlay-dataplane heeft de huidige overlayconfiguratie nog niet gerealiseerd',
    overlaysError: 'Laatste overlay-reconciliatieronde mislukt: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Wacht op join',
      'joining': 'Bezig met joinen',
      'member': 'Lid'
    },
    tokenTitle: 'Join-token',
    tokenOnce: 'Wordt alleen nu getoond — kopieer hem meteen, hij is later niet meer leesbaar',
    copy: 'Kopiëren',
    copied: 'Gekopieerd',
    close: 'Sluiten',
    revokeTitle: 'Voorregistratie intrekken',
    revoke: 'Intrekken',
    revokeError: 'De registratie kon niet worden ingetrokken',
    promote: 'Promoveren tot store member',
    demote: 'Rol store-member weghalen',
    troubleshoot: 'Probleemoplossing',
    promoteTitle: 'Promoveren tot store member',
    demoteTitle: 'Rol store-member weghalen',
    promoteHint: 'De node treedt toe tot het quorum van de YugabyteDB-masters. Echte HA vraagt drie store members.',
    demoteHint: 'De node verlaat het masterquorum en stopt zijn store-diensten.',
    storeError: 'De wijziging van het store-memberschap is geweigerd',
    attest: 'Uitgeschakeld bevestigen…',
    attestTitle: 'Node als uitgeschakeld bevestigen',
    attestSubmit: 'Uitgeschakeld bevestigen',
    attestConfirm: "Je verklaart deze node uitgeschakeld, op eigen risico: een node bevestigen die in werkelijkheid leeft, riskeert VM's die dubbel draaien. Zijn tasks worden op mislukt gezet en de authority van zijn VM's wordt overdraagbaar.",
    attestError: 'De bevestiging is geweigerd',
    attestedChip: 'bevestigd uitgeschakeld',
    maintenanceChip: 'onderhoud',
    guestToolsChip: 'TVirt Guest Tools (ISO-asset lokaal op de node)',
    maintenanceEnter: 'Onderhoud inschakelen',
    maintenanceExit: 'Onderhoud uitschakelen',
    maintenanceEnterTitle: 'Onderhoud inschakelen',
    maintenanceExitTitle: 'Onderhoud uitschakelen',
    maintenanceEnterSubmit: 'Onderhoud inschakelen',
    maintenanceExitSubmit: 'Onderhoud uitschakelen',
    maintenanceEnterConfirm: "De node wordt afgezet en leeggemaakt: de netwerkdiensten en App-instanties waarvan hij de authority houdt worden overgedragen (instanties koud: hier gestopt en geoogst, opnieuw aangemaakt op de doelnode — downtime), draaiende VM's worden live gemigreerd waar mogelijk en anders netjes gestopt, lopende taken maken af, nieuw werk wacht en gestopte VM's verliezen hun authority — Proximity plaatst ze opnieuw bij de volgende start. Niets komt vanzelf terug als het onderhoud eindigt.",
    maintenanceExitConfirm: "De node gaat weer aan het werk en Proximity neemt hem weer mee bij de plaatsing. De VM's komen pas terug wanneer ze worden gestart.",
    maintenanceError: 'Het onderhoudsverzoek is geweigerd',
    maintenancePlanTitle: 'Evacuatieplan',
    maintenancePlanLoading: 'Het evacuatieplan wordt berekend…',
    maintenancePlanError: 'Het evacuatieplan kon niet worden geladen — de drain migreert hoe dan ook waar dat kan en stopt de rest.',
    maintenancePlanEmpty: 'Niets te evacueren op deze node — geen actieve netwerkdienst, geen App-instantie die moet draaien, geen draaiende VM.',
    maintenancePlanSummary: "{migrate} objecten migreren (VM's, netwerkdiensten, App-instanties), {stop} stoppen of blijven waar ze zijn.",
    maintenancePlanReserve_ok: 'Failover-reserve na het leegmaken: intact — er blijft {headroom} GiB startbaar met tolerantie voor het verlies van {n} node(s).',
    maintenancePlanReserve_eroded: 'Failover-reserve na het leegmaken: bijna opgebruikt — er blijft maar {headroom} GiB over van de {reserve} GiB die voor {n} nodestoring(en) vrij worden gehouden.',
    maintenancePlanReserve_exhausted: 'Failover-reserve na het leegmaken: UITGEPUT — er ontbreekt {headroom} GiB van de {reserve} GiB die nodig is om {n} nodestoring(en) te verdragen. Zolang deze node eruit ligt, worden nieuwe VM-starts geweigerd.',
    maintenancePlanReserve_unknown: 'Failover-reserve na het leegmaken: niet te berekenen — geen enkele overgebleven node heeft zijn geheugen gemeld.',
    maintenancePlanReserveHugePages: "Enorme pagina's van {size} na het leegmaken — vrij: {free} van {capacity}, vereist als reserve: {reserve}.",
    maintenancePlanActionMigrate: 'migreert',
    maintenancePlanActionMigrateWarning: 'migreert (soft-regel geschonden)',
    maintenancePlanActionStop: 'stopt',
    maintenancePlanActionBlocked: 'geblokkeerd',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'netwerkdienst',
    maintenancePlanKindApp: 'App-instantie',
    maintenancePlanColdMove: 'Koude verplaatsing: de pod wordt hier gestopt en geoogst en door de worker van de doelnode opnieuw aangemaakt — downtime tot de volgende pass van de doelworker.',
    caFingerprint: 'Fingerprint van de cluster-CA',
    staleChip: 'niet actueel',
    troubleshootTitle: 'Probleemoplossing van de store',
    restartStore: 'Store-diensten herstarten',
    restartHint: 'Als de store dwarsligt, herstart je zijn diensten. Geavanceerd — met beleid gebruiken.',
    restartQueued: 'Herstart-task in de wachtrij',
    restartError: 'De diensten konden niet worden herstart',
    svcActive: 'actief',
    svcWanted: 'gewenst, niet actief',
    svcStopped: 'gestopt',
    noServices: 'Geen dienst gemeld'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: "De GPU-inventaris van het hele cluster, gegroepeerd per model — de per node waargenomen kaarten, met de gemarkeerde registraties en hun tags",
    usbTitle: 'USB-resources',
    usbSubtitle: 'De USB-inventaris van het hele cluster, gegroepeerd per model — de per node waargenomen apparaten, met de registraties van beide modellen (per apparaat, per poort) en hun tags',
    markedChip: '{n} bruikbaar voor TVirt',
    orphanChipGpu: '{n} verweesd',
    orphanChipUsb: '{n} verweesd',
    colNode: 'Node',
    colRegistration: 'Registratie',
    noRegsHint: 'Geen registratie — een apparaat markeer je als "bruikbaar voor TVirt" in de dialoog van de node (Nodes › node › Instellingen).',
    colDevice: 'Apparaat',
    colObserved: 'Waargenomen',
    colRegs: 'Registraties',
    regsNone: 'geen',
    colPci: 'PCIe-adres',
    colIdentity: 'Identiteit / poort',
    colClasses: 'Klassen (tags)',
    colActions: 'Acties',
    manageOnNode: 'Beheren op node {node} (de markering leeft in de dialoog van de node)',
    introTitle: 'De clusterinventaris van de USB- en PCIe-apparaten die bruikbaar zijn voor TVirt©.',
    introStep1: "1. De nodes ontdekken hun eigen GPU's en USB-apparaten zelf (inventarisatie in de heartbeat).",
    introStep2: '2. Een apparaat markeer je als "bruikbaar voor TVirt" in de dialoog van de NODE (Nodes › node › Instellingen) — de markering bindt het aan vfio en registreert het hier.',
    introStep3: "3. Hier geef je de registraties hun KLASSEN via tags (bv. gpu_class=compute): de eisen van de VM's vragen om een klasse en de scheduler kiest een node met een vrij, compatibel apparaat.",
    colMode: 'Modus',
    colState: 'Status',
    colNotes: 'Notities',
    colTags: 'Tags',
    modeDevice: 'per apparaat',
    modePort: 'per poort',
    usable: 'bruikbaar',
    orphanGpu: 'verweesd',
    orphanUsb: 'verweesd',
    hubChip: 'hub',
    orphanPortsTitle: 'Per-poortregistraties zonder aangesloten apparaat — sluit een apparaat opnieuw aan of haal de markering weg op de node',
    gpusEmpty: 'Nog geen enkele GPU waargenomen op welke node dan ook',
    usbEmpty: 'Nog geen enkel USB-apparaat waargenomen op welke node dan ook'
  },

  // Gedeelde woordenschat van de instellingenformulieren (refactoring 2026-07-24): de
  // security-velden voeden de card van de pagina Cluster, de nodevelden de pagina
  // node-settings — de pagina /system/settings waarvoor ze ontstonden is dood.
  settings: {
    passwordMinLength: 'Minimale wachtwoordlengte',
    sessionIdle: 'Time-out bij inactieve sessie (minuten)',
    lockoutThreshold: 'Blokkeren na mislukte pogingen',
    lockoutDuration: 'Duur van de blokkade (minuten)',
    keyboardLayout: 'Toetsenbordindeling',
    keyboardLayoutHint: 'bv. nl, en-us — leeg voor de QEMU-standaard',
    syslogEndpoint: 'Syslog-endpoint',
    syslogEndpointHint: 'host:poort — leeg om het doorsturen uit te schakelen',
    syslogTls: 'TLS',
    maxQueued: 'Maximaal aantal tasks in de wachtrij',
    concurrency: 'Gelijktijdigheid van de worker',
    concurrencyHint: 'Direct door de worker toegepast',
    notesTitle: 'Notities',
    save: 'Opslaan',
    saved: 'Instellingen opgeslagen',
    saveError: 'De instellingen konden niet worden opgeslagen'
  },
  localSettings: {
    derivedChip: 'afgeleid',
    derivedTip: 'Dit device is EIGENDOM van de fabric-derivatie (H2): de editor weigert het aan te raken — wijzig de fabric (of de bekabeling) en pas opnieuw toe, of neem het hieronder terug.',
    takeOwnership: 'Eigendom overnemen',
    takeOwnershipTitle: 'Eigendom overnemen (take-ownership)',
    takeOwnershipConfirm: '{name} verlaat het fabric-blok en wordt weer een HANDMATIG device dat deze editor bestuurt. De node wordt afgeweken, en de volgende derivatie-apply weigert erop (manualConflict) tot u het hernoemt of verwijdert — of de fabric corrigeert.',
    nodeSettingsTitle: 'Node-instellingen',
    nodeSettingsSubtitle: 'Wat deze node toepast — de wachtrij met tasks, de console, het doorsturen van logs — plus zijn tags en notities',
    baseTitle: 'Hostreserveringen (TVirt Proximity)',
    baseSubtitle: "CPU en RAM gereserveerd voor het besturingssysteem van de host — de invoer voor de empirische capaciteit waarmee Proximity de VM's plaatst",
    baseMemory: 'Basis-RAM (MiB)',
    baseMemoryHint: "Waargenomen totaal: {total} MiB. Bruikbaar voor VM's = totaal − basis − RAM van de draaiende VM's die hier geplaatst zijn.",
    baseMemoryHintNoTotal: "Bruikbaar voor VM's = waargenomen totaal − basis − RAM van de draaiende VM's die hier geplaatst zijn.",
    baseCpu: 'Basis-CPU-cores',
    baseCpuHint: "Waargenomen logische CPU's: {total}. Alleen gebruikt als rankinggewicht — overcommit van vCPU is normaal.",
    baseCpuHintNoTotal: 'Alleen gebruikt als rankinggewicht — overcommit van vCPU is normaal.',
    baseHint: 'RAM is de harde toelatingspoort: een VM die niet in het bruikbare RAM past, wordt geweigerd met een sprekende foutmelding. Verhoog de basis op de hosts die store members of Ceph-daemons herbergen.',
    placementTitle: 'Fysieke plaatsing',
    placementSubtitle: 'Waar deze server fysiek staat — eenmalig gedeclareerd, waar het ook voor nodig is',
    placementHint: 'De plaatsing stuurt de CRUSH-hiërarchie van elk Ceph-cluster met een OSD op deze server: een wijziging opslaan brengt hun maps via een task weer op één lijn (host → rack → … → root). Gedeeltelijke verklaringen mogen — lege niveaus vallen weg. De namen worden over de hele map gedeeld: twee servers in hetzelfde rack verklaren dezelfde racknaam.',
    placementNameInvalid: 'DNS-veilige naam (kleine letters, cijfers, koppeltekens)',
    placementEmpty: 'Leeg = niet gedeclareerd',
    placementLevel: {
      chassis: 'Chassis',
      rack: 'Rack',
      row: 'Rij',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Ruimte',
      datacenter: 'Datacenter',
      zone: 'Zone',
      region: 'Regio'
    },
    cablingTitle: 'Bekabeling',
    cablingSubtitle: 'Op welke switchpoort elke interface is aangesloten — de verklaring leeft op de node (Annex O.9)',
    cablingHint: 'Eén kabel per NIC, één kabel per poort over de hele fleet (de API weigert en noemt de eigenaar). Bekabelen naar een poort die lid is van een LAGG mag — dat is het bond-geval: de toekomstige afleiding geeft het weer als LACP.',
    cablingInterface: 'Interface',
    cablingNotCabled: '— niet aangesloten —',
    cablingNoInterfaces: 'Geen netwerkinterface waargenomen',
    disksTitle: 'Schijven',
    disksSubtitle: 'Waargenomen blockdevices — één scan per reconciliatieronde; markeer hier de schijven die als Ceph-OSD bruikbaar zijn (N.15: de geschiktheid is expliciet)',
    colDataDisk: 'Dataschijf',
    dataDisksHint: 'Een apparaat aanvinken verklaart het bruikbaar als OSD; het serienummer is zijn identiteitspin — overgenomen uit de hardware wanneer de schijf het meldt, anders zelf gemunt (tvirt-…). De registratiedialoog van Ceph biedt alleen de gedeclareerde schijven aan.',
    diskDeclaredSerial: 'gedeclareerd',
    diskNotObserved: 'gedeclareerd maar niet waargenomen — sluit het apparaat opnieuw aan of haal het vinkje weg',
    noDisks: 'Nog geen blockdevice waargenomen',
    colSerial: 'Serienummer',
    colModel: 'Model',
    colSize: 'Grootte (GiB)',
    colDiskType: 'Type',
    colInUse: 'In gebruik',
    colObservedAt: 'Waargenomen',
    diskInUse: 'in gebruik',
    diskFree: 'vrij',
    diskMounted: 'gemount',
    diskPartitions: 'partities',
    passthroughTitle: 'Passthrough-apparaten',
    passthroughSubtitle: "Waargenomen GPU's en USB-apparaten — markeer hier wat TVirt aan de VM's mag doorgeven; de markering registreert de identiteit van het apparaat (ronde U1+G1)",
    passthroughHint: 'De markering registreert het apparaat (een stabiel id — het doelwit van tags en klasse-eisen). Bij een gemarkeerde GPU wordt de HELE IOMMU-groep in één klap aan vfio-pci gebonden — die verlaat de host onmiddellijk; de markering weghalen hangt de native driver terug. Voor USB bestaan beide geratificeerde modellen: per apparaat (vendor+product, waar het ook is ingeplugd) en per fysieke poort (de VM krijgt wat er ook in zit). USB bindt niet bij de markering — de attach gebeurt tijdens de runtime van de VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Bruikbaar voor TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI-adres',
    colDriver: 'Driver',
    colVerdict: 'Oordeel',
    gpuEligible: 'Geschikt',
    gpuIneligible: 'Niet geschikt',
    gpuReason: {
      'no-iommu': 'IOMMU niet actief op de host',
      'group-spans-slots': 'IOMMU-groep niet geïsoleerd: hij loopt door over andere slots',
      'multiple-display': 'IOMMU-groep niet geïsoleerd: meer dan één videofunctie',
      'foreign-function': 'IOMMU-groep niet geïsoleerd: hij bevat een vreemde functie'
    },
    vfioNotReady: 'De IOMMU is niet actief op deze host: geen enkele GPU is geschikt zolang het hostplatform hem niet inschakelt (OEM-ISO) — TVirt raakt kernel args nooit tijdens runtime aan.',
    vfioMissingKernelArg: 'De IOMMU is niet actief op deze host: de firmware meldt VT-d/AMD-Vi (ACPI-tabel DMAR/IVRS aanwezig) maar de kernel arg ontbreekt — voeg intel_iommu=on (Intel) toe of haal amd_iommu=off (AMD) van de command line van de kernel af en start opnieuw op. TVirt raakt kernel args nooit tijdens runtime aan.',
    vfioFirmwareDisabled: 'De IOMMU is niet actief op deze host: VT-d/AMD-Vi is uitgeschakeld in de firmware (geen ACPI-tabel DMAR/IVRS) of de CPU ondersteunt het niet — schakel het in de firmware-setup in, geen enkele kernel arg kan het aanzetten. TVirt raakt de host nooit tijdens runtime aan.',
    gpuBindError: 'vfio-pci-bind mislukt op {address}: {error}',
    firewallBridgesTitle: 'Firewall op onbeheerde bridges',
    firewallBridgesSubtitle: "De handgebouwde bridges op deze node waarvan de setup instemt met door TVirt gerenderde firewallchains op aangesloten gast-NIC's",
    firewallBridgesHint: 'TVirt raakt de vreemde bridge nooit aan — de chain ankert op de tap/veth, en die is altijd van TVirt zelf. De lijst is een toestemmingspoort: default-deny en anti-spoof kunnen breken wat een handmatige setup verwacht, dus een NIC met firewall op een onbeheerde bridge die hier NIET vermeld staat wordt geweigerd met een sprekende foutmelding.',
    firewallBridgesEmpty: 'Geen enkele onbeheerde bridge stemt op deze node in met door TVirt gerenderde firewallchains.',
    firewallBridgeAdd: 'Bridge toevoegen',
    firewallBridgeInvalid: 'Geen Linux-interfacenaam (1-15 tekens, zonder slash of spatie)',
    firewallBridgeDuplicate: 'Naam staat al in de lijst',
    colMarkDevice: 'Per apparaat',
    colMarkPort: 'Per poort',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Poort',
    passthroughOrphan: 'verweesd — geregistreerd maar niet meer gedetecteerd: sluit het opnieuw aan of haal de markering weg',
    noGpus: 'Nog geen GPU waargenomen',
    noUsb: 'Nog geen USB-apparaat waargenomen',
    networkGeneration: 'Netwerkgeneratie',
    applied: 'Toegepast',
    converged: 'synchroon',
    behind: 'achter — {m} / {n}',
    notConfigured: 'niet geconfigureerd',
    rollbackBody: 'Toepassen van generatie {gen} mislukt: {error}',
    rolledBackChip: 'rollback uitgevoerd',
    nicsTitle: 'NIC',
    nicsSubtitle:
      "Het register van de beheerde NIC's — de registratie ÍS de beheerverklaring: een geregistreerde NIC zonder configuratie wordt niet aangeraakt (clear-if verklaart hem expliciet schoon), een niet-geregistreerd apparaat wordt nooit aangeraakt",
    addNic: 'NIC registreren',
    addNicTitle: 'NIC registreren (add-nic)',
    delNic: 'Beheer beëindigen',
    delNicTitle: 'Beheer beëindigen (del-nic)',
    delNicConfirm:
      'Het beheer van {name} eindigt: de registerpost en zijn configuratie worden verwijderd en het TVirt-profiel weggehaald — het apparaat blijft zoals Linux het heeft.',
    nicName: 'Naam van het apparaat',
    nicMac: 'Permanent MAC-adres',
    nicMacHint: 'het permanente hardware-MAC — de stabiele identiteit die de TVirt Server Installer vastlegt',
    colObserved: 'Waargenomen',
    nicObserved: 'waargenomen',
    nicNotObserved: 'niet waargenomen',
    nicMacMismatch: 'Afwijkend MAC — waargenomen {mac}',
    noNics: 'Geen NIC geregistreerd — registreer een apparaat om het te gaan beheren',
    noManagedDevices: 'Geen beheerd apparaat — registreer eerst een NIC, alles bouwt voort op het register',
    inventoryTitle: 'Waargenomen apparaten',
    inventorySubtitle: 'Bij elke reconciliatieronde bijgewerkt door de worker van de node — de validatie toetst de apparaatnamen aan deze inventaris',
    colDevice: 'Apparaat',
    colType: 'Type',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Snelheid',
    colTopology: 'Topologie',
    colMtu: 'MTU',
    colAddresses: 'Adressen',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP aggregeert niet',
    noInventory: 'Tot nu toe geen apparaat gemeld',
    interfacesTitle: 'Interfaces',
    interfacesSubtitle:
      "L3-configuratie van de geregistreerde NIC's en de gedeclareerde logische apparaten — set-if vervangt het hele blok, edit-if past de eigenschappen bij, clear-if maakt het leeg (expliciete opschoning)",
    colConfig: 'Gewenste configuratie',
    clean: 'schoon',
    setIf: 'Adressering wijzigen',
    setIfTitle: 'Adressering wijzigen (set-if)',
    editIf: 'Eigenschappen wijzigen',
    editIfTitle: 'Eigenschappen wijzigen (edit-if)',
    clearIf: 'Configuratie leegmaken',
    clearIfTitle: 'Configuratie leegmaken (clear-if)',
    clearIfConfirm: 'De configuratie van de interface wordt leeggemaakt. Een schone interface is de voorwaarde om hem als lid van een bond/bridge of als parent van een VLAN in te zetten.',
    ip4Mode: 'IPv4-modus',
    ip6Mode: 'IPv6-modus',
    modeUnconfigured: 'Niet geconfigureerd',
    modeStatic: 'Statisch',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-adressen',
    ip6Addresses: 'IPv6-adressen',
    addressesHint: "CIDR, gescheiden door komma's",
    gw4: 'IPv4-gateway',
    gw6: 'IPv6-gateway',
    dns: 'DNS-servers',
    dnsHint: "gescheiden door komma's — leeg wist de DNS (set-if vervangt het blok)",
    routes4: 'Statische IPv4-routes',
    routes6: 'Statische IPv6-routes',
    routeTo: 'Bestemming (CIDR)',
    routeVia: 'Via',
    addRoute: 'Route toevoegen',
    routesChip: 'routes',
    mtu: 'MTU',
    mtuHint: 'leeg = standaard van de driver',
    vlansTitle: 'VLAN',
    addVlan: 'VLAN toevoegen',
    addVlanTitle: 'VLAN toevoegen (add-vlan)',
    delVlanTitle: 'VLAN verwijderen (del-vlan)',
    vlanParent: 'Parent-interface',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Naam van het apparaat',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Geen VLAN gedeclareerd',
    bondsTitle: 'Bond',
    addBond: 'Bond toevoegen',
    addBondTitle: 'Bond toevoegen (add-bond)',
    editBondTitle: 'Bond bewerken',
    editBond: 'Bond opslaan',
    delBondTitle: 'Bond verwijderen (del-bond)',
    bondName: 'Naam van de bond',
    members: 'Leden',
    membersHint: 'de leden moeten schone interfaces zijn (zonder L3-configuratie)',
    bondMode: 'Modus',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primair lid',
    rate: 'LACP-rate',
    hash: 'Hashbeleid bij verzenden',
    colMembers: 'Leden',
    colMode: 'Modus',
    noBonds: 'Geen bond gedeclareerd',
    bridgesTitle: 'Bridge',
    addBridge: 'Bridge toevoegen',
    addBridgeTitle: 'Bridge toevoegen (add-bridge)',
    editBridgeTitle: 'Bridge bewerken',
    editBridge: 'Bridge opslaan',
    delBridgeTitle: 'Bridge verwijderen (del-bridge)',
    bridgeName: 'Naam van de bridge',
    stp: 'STP',
    stpOn: 'STP aan',
    stpOff: 'STP uit',
    colStp: 'STP',
    noBridges: 'Geen bridge gedeclareerd',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Hostname instellen',
    setHostnameTitle: 'Hostname instellen (set-hostname)',
    hostnameHint: 'Alleen OS-identiteit — de naam van de node in het cluster wordt niet aangeraakt',
    notSet: 'niet ingesteld',
    staticHostsTitle: 'Statische hostvermeldingen',
    addStaticHost: 'Vermelding toevoegen',
    addStaticHostTitle: 'Statische hostvermelding toevoegen',
    delStaticHostTitle: 'Statische hostvermelding verwijderen',
    hostIp: 'IP-adres',
    hostNames: 'Namen',
    hostNamesHint: "gescheiden door komma's of spaties",
    colIp: 'IP',
    colNames: 'Namen',
    noStaticHosts: 'Geen statische hostvermeldingen',
    delConfirm: '{name} wordt uit het gewenste document weggehaald — de worker van de node convergeert met een NetworkManager-checkpoint en automatische rollback.',
    remove: 'Weghalen',
    opError: 'De netwerkoperatie is geweigerd'
  }
}
